import React from 'react';
import PropTypes from 'prop-types';

function TriangleButton({ active, activeColor, background, border, color }) {
  return (
    <>
      {background && (
        <path
          d="M636.66 212.476C649.858 212.476 660.557 201.777 660.557 188.58C660.557 175.382 649.858 164.683 636.66 164.683C623.463 164.683 612.764 175.382 612.764 188.58C612.764 201.777 623.463 212.476 636.66 212.476Z"
          fill={background}
        />
      )}
      <path
        d="M636.66 212.476C649.858 212.476 660.557 201.777 660.557 188.58C660.557 175.382 649.858 164.683 636.66 164.683C623.463 164.683 612.764 175.382 612.764 188.58C612.764 201.777 623.463 212.476 636.66 212.476Z"
        fill={activeColor}
        fillOpacity={active ? 1 : 0}
      />
      <path
        d="M636.896 168.928L619.587 198.902L654.2 198.903L652.72 196.338L636.896 168.928ZM636.896 175.76L648.28 195.485L625.507 195.489L636.896 175.76Z"
        fill={color}
      />
      <path
        d="M636.896 163.547C623.226 163.547 612.102 174.672 612.102 188.344C612.102 202.016 623.226 213.14 636.896 213.14C650.572 213.14 661.697 202.016 661.697 188.344C661.697 174.672 650.572 163.547 636.896 163.547ZM636.896 167.43C648.47 167.43 657.804 176.771 657.804 188.344C657.804 199.916 648.47 209.258 636.896 209.258C625.322 209.258 615.983 199.916 615.983 188.344C615.983 176.771 625.322 167.43 636.896 167.43Z"
        fill={border}
      />
    </>
  );
}

TriangleButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  background: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

TriangleButton.defaultProps = {
  active: false,
  activeColor: '#FF0000',
  background: null,
  border: '#6F727C',
  color: '#464A56',
};

export default TriangleButton;
